import React from "react";
import "./ArticleConclusion.css";

const ArticleConclusion = ({ children }) => {
  return (
    <aside className="article-conclusion">
      <h2 className="article-conclusion__title">Conclusion</h2>
      <div className="article-conclusion__body">{children}</div>
    </aside>
  );
};

export default ArticleConclusion;
